import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ContentTypeEnum, IContentCommentNotice, INoticeParams } from 'lingo2-models';
import { IBaseNotification } from '../../base-notification/base-notification.component';
import { BaseComponent } from '../base.component';

@Component({
  selector: 'app-content-comment',
  templateUrl: './content-comment.component.html',
  styles: [''],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContentCommentComponent extends BaseComponent {
  public params: IContentCommentNotice;
  public base: IBaseNotification;

  constructor(protected translate: TranslateService, protected readonly cdr: ChangeDetectorRef) {
    super(cdr);
  }

  @Input() set notification(notification: INoticeParams) {
    this.params = notification.params as IContentCommentNotice;
    this.base = {
      title: 'notifications.content_comment.title',
      icon: 'notice-comment',
      created_at: notification.created_at,
      modifier: null,
    };
  }

  public isMicroText() {
    return this.params.content_type === ContentTypeEnum.microtext;
  }

  public get microTextTitle() {
    return `<a class='link-base' href='${this.filteredUrl(this.params.content_url)}'>${this.translate.instant(
      'notifications.content_comment.post',
    )}</a>`;
  }
}
